import React, { useRef } from "react";
import CardLog from "./CardLog";
import { useVirtualizer } from "@tanstack/react-virtual";
import PropTypes from "prop-types";
const CardsLog = ({ data }) => {
  const parentRef = useRef(null);

  const rowVirtualizer = useVirtualizer({
    count: data.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 220,
    overscan: 5,
  });

  return (
    <div ref={parentRef}>
      <div
        style={{
          height: `${rowVirtualizer.getTotalSize()}px`,
          width: "100%",
          position: "relative",
        }}
      >
        {rowVirtualizer.getVirtualItems().map((virtualRow) => {
          const item = data[virtualRow.index];

          return (
            <div
              key={item.uid_transaction}
              ref={rowVirtualizer.measureElement}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                transform: `translateY(${virtualRow.start}px)`,
              }}
            >
              <CardLog data={item} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
CardsLog.propTypes = {
  data: PropTypes.array,
};
export default CardsLog;
